import { Controller as BaseController } from 'stimulus'

export class Controller extends BaseController {
  onFiltersTriggered(searchEvent) {
    const newSearchParams = searchEvent.detail.paramsObj

    // Proactively disables any <input> elems scoped under localities which are not
    // present in the new search params anymore.
    if (this.scopedByLocalities) this.disableInputsFromStaleLocalities(newSearchParams)
  }

  onSearchTriggered(searchEvent) {
    const newSearchParams = searchEvent.detail.paramsObj

    if (this.scopedByLocalities) this.reloadItemsIfLocalitiesChanged(newSearchParams)
  }

  disableInputsFromStaleLocalities(newSearchParams) {
    const currentSearchParams = this.contentLoader.urlParamsValue

    const prevLocations = currentSearchParams.locations || []
    const newLocations = newSearchParams.locations || []

    const staleLocalities = prevLocations.filter(loc => !newLocations.includes(loc))

    staleLocalities.forEach((loc) => {
      this.element.querySelectorAll(`input[data-item-locality="${loc}"]`).forEach((input) => {
        input.disabled = true
      })
    })
  }

  reloadItemsIfLocalitiesChanged(newSearchParams) {
    const currentSearchParams = this.contentLoader.urlParamsValue
    const locationsChanged = JSON.stringify(currentSearchParams.locations) !== JSON.stringify(newSearchParams.locations)

    if (locationsChanged) this.contentLoader.reload({ ...newSearchParams, _variant: 'longlist' })
  }

  // Most of the logic in this controller is to deal with stuff related to
  // lists that are scoped/grouped by localities.
  get scopedByLocalities() {
    return this.element.querySelector("[data-list-scoped-by-localities='true']")
  }

  get contentLoader() {
    return this.element['content-loader']
  }
}
